import React from 'react'
import Container from '../../components/Container'
import Logo from '../../images/tas_logo.png';

import './index.scss';

const Header = () => {
    return (<div className="header">
        <Container>
            <div className="header__wrapper">
                <div className="header__title bold">Депозит</div>
                <div className="header__logo">
                    <img src={Logo} alt={'TAS Logo'} />
                </div>
            </div>
        </Container>
    </div>)
}

export default Header;